import React from "react";
import { Link } from "react-router-dom";

import numberWithCommas from '../common/number';

const RenderRegisterList = ({ list,lastBookElementRef,onClick }) => {
 
//console.log(list)
  return (
    <>
      {list &&
       
        list.map((item,index) => {
          if (list.length === index +1)
         
        { return (
          <div className="container-fluid" key={item.AutoID}>
            <div className="card border-secondary m-1 ">
              <div ref={lastBookElementRef} className="row m-1">
                <div className="container col-xs-6 col-sm-4 col-md-2 lg-1 ">
                  <div style={{ fontSize: "22px" }}>
                    

                    { item.RCID === 0 ? <span className="badge rounded-pill bg-warning text-dark">
                      {item.No}
                    </span>:<span className="badge rounded-pill bg-primary">
                      {item.No}
                    </span>
                      }

                  </div>
                  <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                  <div style={{ fontSize: "14px" }}>{item.Customer_Name}</div>
                  <div style={{ fontSize: "14px" }}>
                    {item.CustomerTypeName}
                  </div>
                </div>

                <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      ใบนำส่ง :
                      <small style={{ fontSize: "14px" }}> {item.DO}</small>{" "}
                    </h6>
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      วัตถุประสงค์ :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.aim_name}
                      </small>
                    </h6>
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      ประเภทสินค้า :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.type_name}
                      </small>
                    </h6>
                  </div>

                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      สินค้า :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.ProductName}
                      </small>
                    </h6>
                  </div>
                  <div></div>
                </div>
                <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      ประเภทรถ :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.truck_typename}
                      </small>
                    </h6>
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      ทะเบียนหัว :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.first_driven_no}
                      </small>
                    </h6>
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      ทะเบียนหาง :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.second_driven_no}
                      </small>
                    </h6>
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    <h6>
                      {" "}
                      วันที่ลงสินค้า :
                      <small style={{ fontSize: "14px" }}>
                        {" "}
                        {item.queue_date}
                      </small>
                    </h6>
                  </div>
                </div>

                <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                  <div>
                    <h6>
                      {" "}
                      เข้า :
                      <small style={{ fontSize: "18px" }}>
                        {" "}
                        <span className="badge rounded-pill bg-info text-dark">
                          {numberWithCommas(item.receive_weightin)}
                        </span>
                      </small>
                    </h6>
                  </div>

                  <div>
                    <h6>
                      {" "}
                      ออก :
                      <small style={{ fontSize: "18px" }}>
                        {" "}
                        <span className="badge rounded-pill bg-warning text-dark">
                          {numberWithCommas(item.receive_weightout)}
                        </span>
                      </small>
                    </h6>
                  </div>

                  <div>
                    <h6>
                      {" "}
                      สุทธิ :
                      <small style={{ fontSize: "18px" }}>
                        {" "}
                        <span className="badge rounded-pill bg-success">
                          {numberWithCommas(item.receive_weightnet)}
                        </span>
                      </small>
                    </h6>
                  </div>
                </div>

       
                <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                   
                      <h6 style={{ fontSize: "14px" }}>
                        {" "}
                        Status:
                        <small style={{ fontSize: "18px" }}>
                          {" "}
                          { item.RCID ===0 && item.receive_weightin !== "Waiting" &&   item.receive_weighnet !== "Waiting" ?  
                          <span className="badge rounded-pill bg-secondary">
                            {"ไม่มีรายงานการzoom"}
                          </span>
                          
                          :  item.RCID ===0 && item.receive_weightin !== "Waiting"  ?  
                          <span className="badge rounded-pill bg-info text-dark">
                            {"zoomปลายทางwait"}
                          </span>
                          
                          :   item.RCID ===0 ?  
                          
                     <span className="badge rounded-pill bg-warning text-dark">
                            {"zoomต้นทางWait"}
                          </span>
                          
                          :   item.step2 === 0 ?  <span className="badge rounded-pill bg-warning text-dark">
                            {"zoomปลายทางWait"}
                          </span>
                          : <span className="badge rounded-pill bg-success">
                          {"zoomสมบูรณ์"}
                        </span>
                          }



                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        สถานที่ลง :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.storename}
                        </small>
                      </h6>
                    </div>
                    <div>
                    { item.rccomment ? <span  className="badge bg-danger">
                              {"หมายเหตุ"}    {item.rccomment}
                                </span>:null}
                                </div>
                    { item.RCID ===0  && item.receive_weightin !== "Waiting" && item.receive_weighnet !== "Waiting" ?  <button
                      type="button"
                      className="btn btn-secondary btn-sm m-2"
                   
                    >
                      ไม่มีรายงานการzoom
                    </button>     : item.RCID ===0  && item.receive_weightin !== "Waiting"  ?  <button
                      type="button"
                      className="btn btn-info btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      zoomตรวจสอบปลายทาง
                    </button>  : item.RCID ===0   ?  <button
                      type="button"
                      className="btn btn-warning btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      zoomตรวจสอบต้นทาง
                    </button>  :  item.step2 ===0 ? <button
                      type="button"
                      className="btn btn-info btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                       zoomตรวจสอบปลายทาง
                    </button> :<button
                      type="button"
                      className="btn btn-success btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      Details
                    </button>
                    
                    }
                  </div>
              </div>
            </div>
          </div>
        );} else 
        {
          return (
            <div className="container-fluid" key={item.AutoID}>
              <div className="card border-secondary m-1">
                {/* <div className="card-body"> */}
                <div className="row m-1">
                  <div className="container col-xs-6 col-sm-4 col-md-2 lg-1 ">
                    <div style={{ fontSize: "22px" }}>
                    { item.RCID === 0 ? <span className="badge rounded-pill bg-warning text-dark">
                      {item.No}
                    </span>:<span className="badge rounded-pill bg-primary">
                      {item.No}
                    </span>
                      }
                    </div>
                    <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                    <div style={{ fontSize: "14px" }}>{item.Customer_Name}</div>
                    <div style={{ fontSize: "14px" }}>
                      {item.CustomerTypeName}
                    </div>
                  </div>
                  <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        ใบนำส่ง :
                        <small style={{ fontSize: "14px" }}> {item.DO}</small>{" "}
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        วัตถุประสงค์ :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.aim_name}
                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        ประเภทสินค้า :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.type_name}
                        </small>
                      </h6>
                    </div>

                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        สินค้า :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.ProductName}
                        </small>
                      </h6>
                    </div>
                    <div></div>
                  </div>
                  <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        ประเภทรถ :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.truck_typename}
                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        ทะเบียนหัว :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.first_driven_no}
                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        ทะเบียนหาง :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.second_driven_no}
                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        วันที่ลงสินค้า :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.queue_date}
                        </small>
                      </h6>
                    </div>
                  </div>

                  <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <h6>
                        {" "}
                        เข้า :
                        <small style={{ fontSize: "18px" }}>
                          {" "}
                          <span className="badge rounded-pill bg-info text-dark">
                            {numberWithCommas(item.receive_weightin)}
                          </span>
                        </small>
                      </h6>
                    </div>

                    <div>
                      <h6>
                        {" "}
                        ออก :
                        <small style={{ fontSize: "18px" }}>
                          {" "}
                          <span className="badge rounded-pill bg-warning text-dark">
                            {numberWithCommas(item.receive_weightout)}
                          </span>
                        </small>
                      </h6>
                    </div>

                    <div>
                      <h6>
                        {" "}
                        สุทธิ :
                        <small style={{ fontSize: "18px" }}>
                          {" "}
                          <span className="badge rounded-pill bg-success">
                            {numberWithCommas(item.receive_weightnet)}
                          </span>
                        </small>
                      </h6>
                    </div>
                  </div>

                  <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <h6 style={{ fontSize: "14px" }}>
                        {" "}
                        Status
                        <small style={{ fontSize: "18px" }}>
                          {" "}
                          { item.RCID ===0 && item.receive_weightin !== "Waiting" &&   item.receive_weighnet !== "Waiting" ?  
                          <span className="badge rounded-pill bg-secondary">
                            {"ไม่มีรายงานการzoom"}
                          </span>
                          
                          :  item.RCID ===0 && item.receive_weightin !== "Waiting"  ?  
                          <span className="badge rounded-pill bg-info text-dark">
                            {"zoomปลายทางwait"}
                          </span>
                          
                          :   item.RCID ===0 ?  
                          
                     <span className="badge rounded-pill bg-warning text-dark">
                            {"zoomต้นทางWait"}
                          </span>
                          
                          :   item.step2 === 0 ?  <span className="badge rounded-pill bg-warning text-dark">
                            {"zoomปลายทางWait"}
                          </span>
                          : <span className="badge rounded-pill bg-success">
                          {"zoomสมบูรณ์"}
                        </span>
                          }


                        </small>
                      </h6>
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <h6>
                        {" "}
                        สถานที่ลง :
                        <small style={{ fontSize: "14px" }}>
                          {" "}
                          {item.storename}
                        </small>
                      </h6>
                    </div>
                    <div>
                    { item.rccomment ? <span  className="badge bg-danger">
                              {"หมายเหตุ"}    {item.rccomment}
                                </span>:null}
                                </div>
                    { item.RCID ===0  && item.receive_weightin !== "Waiting" && item.receive_weighnet !== "Waiting" ?  <button
                      type="button"
                      className="btn btn-secondary btn-sm m-2"
                   
                    >
                      ไม่มีรายงานการzoom
                    </button>     : item.RCID ===0  && item.receive_weightin !== "Waiting"  ?  <button
                      type="button"
                      className="btn btn-info btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      zoomตรวจสอบปลายทาง
                    </button>  : item.RCID ===0   ?  <button
                      type="button"
                      className="btn btn-warning btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      zoomตรวจสอบต้นทาง
                    </button>  :  item.step2 ===0 ? <button
                      type="button"
                      className="btn btn-info btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                       zoomตรวจสอบปลายทาง
                    </button> :<button
                      type="button"
                      className="btn btn-success btn-sm m-2"
                      onClick={() => onClick(item.AutoID)}
                    >
                      Details
                    </button>
                    
                    }
                  </div>
                </div>
              </div>
            </div>
          );

        }}

        
        )}
    </>
  );
};

export default RenderRegisterList;
